import Repository from "./Repository";

const resource = "";

export default {
  apiPost(payload) {
    if (payload["getType"] == "getProjektData") {
      return Repository.post(`${resource}/user/apipost`, { payload });
    }
  },
  startLogin(payload) {
    return Repository.post(`${resource}/user/startlogin`, { payload });
  },
  resendPass(payload) {
    return Repository.post(`${resource}/user/resendpass`, { payload });
  },

  savePruefung(payload) {
    return Repository.post(`${resource}/user/savepruefung`, { payload });
  },

  saveVersnummer(payload) {
    return Repository.post(`${resource}/user/saveversnummer`, { payload });
  },
  saveUserDaten(payload) {
    return Repository.post(`${resource}/user/saveuserdaten`, { payload });
  },
  checkLogin() {
    return Repository.get(`${resource}/user/checklogin`);
  },
  checkLoginDirect(token) {
    return Repository.get(`${resource}/user/keypro/${token}`);
  },

  startLogout() {
    return Repository.get(`${resource}/user/startlogout`);
  },
  getPruefungen() {
    return Repository.get(`${resource}/user/getpruefungen`);
  },
  getHomePruefungen() {
    return Repository.get(`${resource}/user/gethomepruefungen`);
  },
};
